import React from 'react';

class ColumnPanel extends React.Component {
  constructor(props) {
    super(props);
    let columnData = {
      grid_desktop_hd: 2,
      list_desktop_hd: 2,
      grid_desktop: 2,
      list_desktop: 2,
      grid_tablet: 1,
      list_tablet: 1,
      grid_mobile: 1,
      list_mobile: 1,
    };
    if ('columnData' in this.props) {
      columnData = this.props.columnData ? this.props.columnData : columnData;
    }
    this.state = {
      columnData,
    };
  }
  handleValueIncrement(element) {
    const columnData = this.state.columnData;
    let value = parseInt(columnData[element], 10);
    if (element === 'grid_tablet') {
      if ((value + 1) > 3) {
        return;
      }
    } else if (element === 'grid_desktop_hd') {
      if ((value + 1) > 4) {
        return;
      }
    } else if (element === 'grid_desktop') {
      if ((value + 1) > 4) {
        return;
      }
    } else if (element === 'grid_mobile') {
      if ((value + 1) > 2) {
        return;
      }
    } else if (element === 'list_desktop_hd') {
      if ((value + 1) > 2) {
        return;
      }
    } else if (element === 'list_desktop') {
      if ((value + 1) > 2) {
        return;
      }
    } else {
      if ((value + 1) > 12) {
        return;
      }
    }
    value += 1;
    columnData[element] = value;
    this.setState({ columnData });
    this.props.onColumnSubmit(columnData);
  }
  handleValueDecrement(element) {
    const columnData = this.state.columnData;
    let value = parseInt(columnData[element], 10);
    if ((value - 1) < 1) {
      return;
    }
    value -= 1;
    columnData[element] = value;
    this.setState({ columnData });
    this.props.onColumnSubmit(columnData);
  }
  render() {
    return (<div role="tabpanel" className="tab-pane" id="column">
      <div className="grid-choose-option">
      <div className="flex-row">
        <div className="flex-sm-6">
          <h2 className="list-grid-title"> {API.LANG.GRID} </h2>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.GRID_DESKTOP_HD}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
              <p><button onClick={ this.handleValueIncrement.bind(this, 'grid_desktop_hd') }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.handleValueDecrement.bind(this, 'grid_desktop_hd') }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.columnData.grid_desktop_hd !== null ? this.state.columnData.grid_desktop_hd : null }
              </p>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.GRID_DESKTOP}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
            <button onClick={ this.handleValueIncrement.bind(this, 'grid_desktop') }><i className="fa fa-plus"></i></button>
            <button onClick={ this.handleValueDecrement.bind(this, 'grid_desktop') }><i className="fa fa-minus"></i></button>
            {
             // <p><button onClick={ this.handleValueIncrement.bind(this, 'grid_desktop') }><i className="fa fa-plus"></i></button></p>
              // <p><button onClick={ this.handleValueDecrement.bind(this, 'grid_desktop') }><i className="fa fa-minus"></i></button></p>
            }
              <p className="gird-value-count">
                { this.state.columnData.grid_desktop !== null ? this.state.columnData.grid_desktop : null }
              </p>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.GRID_TABLET}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
              <p><button onClick={ this.handleValueIncrement.bind(this, 'grid_tablet') }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.handleValueDecrement.bind(this, 'grid_tablet') }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.columnData.grid_tablet !== null ? this.state.columnData.grid_tablet : null }
              </p>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.GRID_MOBILE}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
              <p><button onClick={ this.handleValueIncrement.bind(this, 'grid_mobile') }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.handleValueDecrement.bind(this, 'grid_mobile') }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.columnData.grid_mobile !== null ? this.state.columnData.grid_mobile : null }
              </p>
            </div>
          </div>
        </div>
        <div className="flex-sm-6">
          <h2 className="list-grid-title"> {API.LANG.LIST} </h2>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.LIST_DESKTOP_HD}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
              <p><button onClick={ this.handleValueIncrement.bind(this, 'list_desktop_hd') }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.handleValueDecrement.bind(this, 'list_desktop_hd') }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.columnData.list_desktop_hd !== null ? this.state.columnData.list_desktop_hd : null }
              </p>
            </div>
          </div>
          <div className="flex-row">
            <div className="flex-sm-3 flex-xs-12">
              <span className="caption">{API.LANG.LIST_DESKTOP}</span>
            </div>
            <div className="flex-sm-9 flex-xs-12">
              <p><button onClick={ this.handleValueIncrement.bind(this, 'list_desktop') }><i className="fa fa-plus"></i></button></p>
              <p><button onClick={ this.handleValueDecrement.bind(this, 'list_desktop') }><i className="fa fa-minus"></i></button></p>
              <p className="gird-value-count">
                { this.state.columnData.list_desktop !== null ? this.state.columnData.list_desktop : null }
              </p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    );
  }
}
ColumnPanel.propTypes = {
  'columnData': React.PropTypes.object,
  'onColumnSubmit': React.PropTypes.func,
};
export default ColumnPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/columnPanel.js
 **/